import React from "react";
import ReactDOM from "react-dom/client";
import("./bootstrap").then(({ default: MainApp }) => {
  const rootEl = document.getElementById("root");
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl);
    root.render(<MainApp />);
  }
});
